(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mypc-navigation-transition"]) return;
  try {
    
(() => {
 if (window.mypcNavigationReady) return;
 window.mypcNavigationReady = true;
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 let timer, fallback, active, restoreFocus, destination;
 const config = () => document.querySelector('[data-mypc-navigation-config]');
 const allowed = root => root && root.dataset.enabled === 'true' && !reduced.matches && (window.innerWidth < 750 ? root.dataset.mobile === 'true' : root.dataset.desktop === 'true');
 const close = () => {
   clearTimeout(timer); clearTimeout(fallback);
   if (!active) return;
   const screen = active; active = null; destination = null;
   screen.hidden = true;
   document.documentElement.classList.remove('mypc-navigation-active');
   if (restoreFocus?.isConnected) restoreFocus.focus({preventScroll:true});
 };
 const go = () => {
   clearTimeout(timer); clearTimeout(fallback);
   if (!destination) { close(); return; }
   const next = destination; destination = null;
   window.location.assign(next);
 };
 const show = (root, forcedTip) => {
   if (!root) return false;
   const screen = root.querySelector('[data-mypc-navigation-screen]');
   const tips = Array.from(root.querySelectorAll('[data-mypc-navigation-tips] span')).map(node => node.textContent.trim()).filter(Boolean);
   if (!screen || !tips.length) return false;
   clearTimeout(timer); clearTimeout(fallback);
   const duration = Math.max(0.5, Math.min(5, Number(root.dataset.duration) || 2));
   screen.querySelector('[data-mypc-navigation-tip]').textContent = forcedTip || tips[Math.floor(Math.random()*tips.length)];
   screen.style.setProperty('--nav-duration', duration+'s');
   screen.hidden = false;
   document.documentElement.classList.add('mypc-navigation-active');
   active = screen; restoreFocus = document.activeElement;
   screen.querySelector('button').focus({preventScroll:true});
   timer = setTimeout(destination ? go : close, duration*1000);
   fallback = setTimeout(destination ? go : close, 5500);
   return true;
 };
 document.addEventListener('click', event => {
   if (event.target.closest('[data-mypc-navigation-skip]')) {destination ? go() : close(); return;}
   if (event.target.closest('[data-mypc-navigation-preview]')) {show(config()); return;}
   if (active || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || window.Shopify?.designMode || !allowed(config())) return;
   const link = event.target.closest('a[href]');
   if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.closest('form') || link.matches('[data-no-transition]')) return;
   let url;try{url=new URL(link.href,location.href);}catch(_){return;}
   if (url.origin !== location.origin || url.hash || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:$|products(?:\/|$)|collections(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|search(?:\/|$))/.test(url.pathname)) return;
   if (url.pathname+url.search === location.pathname+location.search) return;
   event.preventDefault();
   destination = url.href;
   if (!show(config())) go();
 });
 document.addEventListener('keydown',event=>{
   if(!active)return;
   if(event.key==='Escape'&&!destination){close();return;}
   if(event.key==='Tab'){event.preventDefault();active.querySelector('button').focus();}
 });
 document.addEventListener('shopify:section:unload',close);
 document.addEventListener('shopify:block:select',event=>{const root=event.target.closest('[data-mypc-navigation-config]');if(root)show(root,event.target.textContent.trim());});
 window.addEventListener('pageshow',event=>{if(event.persisted)close();});
})();

  } catch(e) { console.error(e); }
})();
})();
